import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=ecf5158e"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=ecf5158e&prod&lang=scss"
import style1 from "./MenuBar.vue?vue&type=style&index=1&id=ecf5158e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports